import { useCallback } from 'react';
import strings from 'strings';

import { useShowAlert } from './useShowAlert';

export const useCopyToClipboard = () => {
  const { showAlert } = useShowAlert();

  const copyToClipboard = useCallback(
    ({ text, onSuccess, onError }) => {
      if (!navigator.clipboard) return;

      navigator.clipboard
        .writeText(text)
        .then(() => {
          showAlert({
            title: strings.shared.ui.awesome,
            body: strings.shared.ui.copiedToClipboard,
            severity: 'success'
          });
          if (onSuccess) {
            onSuccess();
          }
        })
        .catch(err => {
          if (onError) {
            onError(err);
          }
        });
    },
    [showAlert]
  );

  return { copyToClipboard };
};
